<template>
  <div>
    <v-layout wrap>
      <v-flex >
        <c-search-form
            :rows-per-page-items="[10, 20, 50]"
            :form-name="formName"
            :fields="fields"
            :hiddenFields="hiddenFields"
            key-property="classId"
            search-url="/schoolGameStory/listAll"
            create-url="/schoolGameStory/save"
            delete-url="/schoolGameStory/delete"
            form-type="intable"
            custom-create-new
            @createNew="openCreateDialog"
            :custom-edit-item="true"
            @editItem="openCreateDialog"
            ref="tableData"
            :reload="timeReload"
            :deleteMulti="false"
            orderBy="desc"
            :acceptDelete="true"
            :acceptView="false"
            :accept-edit="true"
            :acceptCreate2=true
            :accept-create=false
            :acceptExport="0"
            @viewItem=""
        >
        </c-search-form>
        <school-create-form
            :propsItem="category"
            :cDialog="visibleCreateDialog"
            @closeCreateDialog="closeCreateDialog"
            :formCreateName="formCreateName"
            :hiddenFields="hiddenFields"
        ></school-create-form>
      </v-flex>
    </v-layout>
  </div>

</template>

<script>
import CSearchForm from "../../../components/form/ManageForm";
import {areaContants} from "@/constants";
import axios from "axios";
import SchoolCreateForm from "@/views/admin/school_game_story/SchoolGameStoryCreate";

export default {
  name: "school-class",
  components: {SchoolCreateForm, CSearchForm},
  data: () => {
    return {
      formName: "Danh sách Game Story",
      formCreateName: "Thêm mới Game Story",
      category: null,
      visibleCreateDialog: false,
      timeReload: 0,
      allAcount: 0,
      hiddenFields: {
        typeId: "0",
      },
      fields: [
        {
          value: "index",
          text: "lang.common.index",
          width: "5%",
          sortable: false,
          headerStyle: "text-align:center",
        },
        {
          value: 'gameId',
          text: 'Game ID',
          search: true,
          sortable:false,
          width: "5%",
          headerStyle: "text-align:center; wrap:true",
        },
        {
          value: 'voice',
          text: 'voice',
          search: true,
          sortable:false,
          width: "15%",
          headerStyle: "text-align:center; wrap:true",
        },
        {
          value: 'text',
          text: 'text',
          search: true,
          sortable:false,
          width: "15%",
          headerStyle: "text-align:center; wrap:true",
        },
        {
          value: 'image',
          text: 'image',
          search: true,
          sortable:false,
          width: "15%",
          headerStyle: "text-align:center; wrap:true",
        },
        {
          value: "action",
          text: "lang.common.actions",
          sortable: false,
          compound: true,
          width: "10%",
          headerStyle: "text-align:center",
        },
      ],
    };
  },

  created() {
  },

  methods: {
    clearFromDate() {
      this.hiddenFields.fromDate = null;
    },
    clearToDate() {
      this.hiddenFields.toDate = null;
    },
    onChangeFromDate(date) {
      this.hiddenFields.fromDate = date;
    },
    onChangeToDate(date) {
      this.hiddenFields.toDate = date;
    },
    openCreateDialog: function (item = null) {
      if (item == null) {
        this.formCreateName = 'Thêm mới ';
      } else {
        this.category = item;
        this.formCreateName = 'Cập nhật';
      }
      this.visibleCreateDialog = true;
    },
    closeCreateDialog: function () {
      this.category = null;
      this.visibleCreateDialog = false;
      this.timeReload = Math.floor(Math.random() * 100);
    },


    createParamLastSearch: function (values) {
      const obj1 = {
        searchImportRequest: JSON.stringify(values),
      };
      const obj2 = this.$route.query;
      return {...obj1, ...obj2};
    },
  },

  destroyed() {
  },
};
</script>
